import { render } from "./Datenschutz.vue?vue&type=template&id=2ac44e0d&scoped=true&ts=true"
import script from "./Datenschutz.vue?vue&type=script&lang=ts"
export * from "./Datenschutz.vue?vue&type=script&lang=ts"

import "./Datenschutz.vue?vue&type=style&index=0&id=2ac44e0d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac44e0d"]])

export default __exports__